import React, { useState } from 'react';
import { styled, useTheme } from '@mui/material';
import Tabs, { tabsClasses } from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabScrollButton from '@mui/material/TabScrollButton';
import useStyles from './ScrollTab.styles.ts';
import { IScrollTabOption } from 'interfaces/NavTabsOptionTypes.ts';

type ScrollTabProps = {
  options: IScrollTabOption[];
  selectedIndex: number;
  setIndex: (idx: number) => void;
  // eslint-disable-next-line no-unused-vars
  onChange?: (idx: number) => void;
};

const CustomTabScrollButton = styled(TabScrollButton)(({ theme }) => ({
  '&.Mui-disabled': {
    opacity: 0.3,
  },
  '&.MuiTabScrollButton-root': {
    color: '#1F1F1F',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  '& .MuiSvgIcon-root': {
    fontSize: '1.5rem', // Adjust the size as needed
    fontWeight: 'bold', // Adjust the boldness as needed
  },
}));

const ScrollTab: React.FC<ScrollTabProps> = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme, tabsClasses);
  const [selectedIndex, setSelectedIndex] = useState(props.selectedIndex);

  const handleChange = (idx: number) => {
    setSelectedIndex(() => idx);
    props.setIndex(idx);
    // props.onChange(props.options[idx].id);
  };

  return (
    <Tabs
      aria-label='visible arrows tabs'
      sx={classes.tabs}
      value={selectedIndex}
      variant='scrollable'
      scrollButtons
      ScrollButtonComponent={CustomTabScrollButton}>
      {props.options && props.options.length
        ? props.options.map((item, idx) => {
            return <Tab key={item.id} label={item.title} onClick={() => handleChange(idx)} />;
          })
        : null}
    </Tabs>
  );
};

export default ScrollTab;
